import { makeT } from "app/client/lib/localization";

const t = makeT("AssistantPrompts");

export interface PromptCategory {
  id: string;
  label: string;
  prompts: string[];
}

/**
 * Returns the sample prompts shown in the home page's assistant composer.
 */
export function getHomeAssistantPrompts(): PromptCategory[] {
  return [
    {
      id: "projects",
      label: t("Projects"),
      prompts: [
        t("A project tracker with tasks, owners, due dates, and status."),
        t("A lightweight CRM for leads, deals, and follow-ups."),
        t("A product backlog with feature requests, bugs, and priorities."),
        t("A ticket queue with priority, assignee, and resolution time."),
        t("A lab notebook with experiments, protocols, and results."),
      ],
    },
    {
      id: "ops",
      label: t("Operations"),
      prompts: [
        t("An inventory list with stock levels and reorder points."),
        t("An IT asset register with devices, owners, and license details."),
        t("A contractor/vendor directory with rates, qualifications, and work history."),
        t("Time sheets by person and project, with weekly totals."),
        t("A lab sample log with IDs, storage location, and collection date."),
      ],
    },
    {
      id: "people",
      label: t("People"),
      prompts: [
        t("A staff directory with teams, managers, and start dates."),
        t("A hiring pipeline with candidates, stages, and interview feedback."),
        t("An event plan with sponsors, registrations, and payments."),
        t("A directory of specialists with expertise, past cases, and notes."),
        t("A class roster with students, schedules, and enrollments."),
      ],
    },
    {
      id: "finance",
      label: t("Finance"),
      prompts: [
        t("A transaction ledger with accounts, categories, and monthly totals."),
        t("Invoices and billable hours with clients, amounts, and paid status."),
        t("A payroll register with employees, pay rates, and pay periods."),
        t("A team expense tracker with who paid, category, and reimbursement status."),
        t("A grant tracker with applications, deadlines, and reporting dates."),
      ],
    },
    {
      id: "other",
      label: t("Other"),
      prompts: [
        t("Ask me questions and design the tables for me."),
        t("I have a messy spreadsheet. Help me structure it."),
        t("A grocery list and weekly meal planner."),
        t("A job search tracker with applications, stages, and follow-ups."),
        t("A recurring tasks list that shows what's due this week."),
      ],
    },
  ];
}
